import { OrderStatusBadge, PaymentBadge, MethodBadge } from "@/components/Badges";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { money, fmtDate } from "@/lib/api";

export function OrdersTable({ orders, onOpen, showClient = true }) {
  if (!orders.length) return <p className="py-10 text-center text-sm text-muted-foreground" data-testid="orders-empty">No orders.</p>;
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Order</TableHead>
            {showClient && <TableHead>Client</TableHead>}
            <TableHead>Date</TableHead>
            <TableHead>Items</TableHead>
            <TableHead>Total</TableHead>
            <TableHead>Payment</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orders.map((o) => {
            const recon = o.items.filter((i) => i.reconstitute).length;
            return (
              <TableRow key={o.id} className="cursor-pointer" onClick={() => onOpen(o.id)} data-testid={`order-row-${o.order_number}`}>
                <TableCell className="font-mono-data">{o.order_number}</TableCell>
                {showClient && <TableCell>{o.client_name}</TableCell>}
                <TableCell className="text-muted-foreground">{fmtDate(o.created_at)}</TableCell>
                <TableCell className="font-mono-data text-xs">
                  {o.items.reduce((s, i) => s + i.quantity, 0)} vials{recon > 0 && <span className="ml-1 text-emerald-400">· {recon} recon</span>}
                </TableCell>
                <TableCell className="font-mono-data">{money(o.total)}</TableCell>
                <TableCell><div className="flex gap-1"><MethodBadge method={o.payment_method} /><PaymentBadge status={o.payment_status} /></div></TableCell>
                <TableCell><OrderStatusBadge status={o.status} /></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
